import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./close.svg?react";

export const CloseIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
